import React from 'react';
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import './App.css';
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/firestore'

import Home from './pages/Home/Home';
import Privacy from './pages/Privacy/Privacy';
import About from './pages/About/About';
import Login from './pages/Login/Login';
import Course from './pages/Course/Course';

import reducer from './store/reducer'


const store = createStore(reducer)

const firebaseConfig = {
  apiKey: "AIzaSyA5RxwzNJ-Jjn47lfHMpSoDSfKicpmKC5M",
  authDomain: "shepha-e338b.firebaseapp.com",
  databaseURL: "https://shepha-e338b.firebaseio.com",
  projectId: "shepha-e338b",
  storageBucket: "shepha-e338b.appspot.com",
  messagingSenderId: "508580867386",
  appId: "1:508580867386:web:7d0c86b5c96f2b2b98f403",
  measurementId: "G-09TTZ8CD2D"
};

function App() {

  firebase.initializeApp(firebaseConfig);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <div className="App">
          <Switch>
            <Route path="/privacy" exact component={Privacy} />
            <Route path="/login" exact component={Login} />
            <Route path="/course">
              <Course />
            </Route>
            <Route path="/" exact component={Home} />
            <Redirect to="/" />
          </Switch>

        </div>
      </BrowserRouter>
    </Provider>

  );
}

export default App;
